import { Component, inject, Renderer2, DOCUMENT, afterNextRender } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from 'components/footer/footer.component';
import { NavmenuComponent } from 'components/navmenu/navmenu.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, FooterComponent, NavmenuComponent]
})
export class AppComponent {
  title = 'BanjoHootson';

  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);

  constructor() {
    afterNextRender(() => {
      this.renderer.addClass(this.document.body, 'loaded');
    });
  }
}
